import React from "react";
import "../../Components/Menu/Menu.css";

export default function Processor() {
  return (
    <div>
      <h4 className="sub-title">Bruk av databehandlere </h4>
      <p className="content">
        Vi inngår databehandleravtaler med alle virksomheter som behandler
        personopplysninger på vegne av oss. Databehandlerne våre kan ikke
        behandle personopplysningene dine på annen måte enn det som er avtalt
        med oss, og beskrevet i denne personvernerklæringen. Vi bruker
        databehandlere blant annet som leverandører av IKT-tjenester.
      </p>
    </div>
  );
}
